module.exports = __webpack_public_path__ + "static/media/mbl_do_card.996e684c.svg";